<template>
  <div>
    <div class="empty-container" v-if="value.group.length === 0">
      <div @click="handleToggleCollapse">Expand to add media questions</div>
    </div>
    <draggable
      class="hook-container"
      group="hooks"
      draggable=".draggable"
      @click.native="handleToggleCollapse"
    >
      <div v-for="question in value.group" :key="question.id" class="hook-item draggable">
        <div class="title">{{ question.mediaClip.title }}</div>
        <div class="artist">{{ question.mediaClip.artist }}</div>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import HookMedia from './HookMedia';

export default {
  name: 'MusicEditorExpanded',
  components: {
    draggable,
    HookMedia,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleToggleCollapse() {
      this.$emit('onToggleCollapse');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/style/_variables_live.scss';

.hook-container {
  line-height: 2;
  cursor: pointer;
}

.hook-item {
  line-height: 1.4;
  padding: 2px 6px;
  border-radius: 6px;
  font-size: 0.8em;
  margin: 2px 4px;
  background-color: $colony-light-gray;
  border: 1px solid darken($colony-light-gray, 15%);
  cursor: grab;
  white-space: nowrap;
  display: inline-block;

  .detail {
    display: inline-block;
    margin-left: 1em;
  }

  .title {
    font-weight: bold;
  }
}

.empty-container {
  cursor: pointer;
  margin: 5px 0;
  text-align: center;
  font-size: 0.8em;
  color: #ccc;
  text-shadow: 2px 2px 2px #efefef;
}
</style>



// WEBPACK FOOTER //
// MusicEditorCollapsed.vue?14fde35c